import React from 'react'
import { Grid, Form } from 'semantic-ui-react'
import { reduxForm } from 'redux-form'
import flowRight from 'lodash/flowRight'
import { translate } from 'loankeeper-common/helpers'
import { GridContainer } from 'shared/StyledComponents'
import FormField from 'shared/newFormElements'
import LKButton from 'shared/LKButton'
import LKModal, { LKModalContainer } from '../LKModal'

export const PIN_CODE_VALIDATION_FORM = 'pin-code-validation-form'
export const PIN_CODE_MODAL = 'pin-code-modal'

const ValidatePinCodeModal = ({ modalInstanceName, handleSubmit, invalid, submitting }) => (
  <LKModal
    name={modalInstanceName}
    size="xxs"
    footer={
      <LKModal.Footer
        sideActions={
          <LKButton alias="ok" onClick={handleSubmit} disabled={invalid || submitting} loading={submitting}>
            {translate('frm_dialog_check-cmd_finish')}
          </LKButton>
        }
      />
    }
  >
    <Form onSubmit={handleSubmit}>
      <GridContainer>
        <Grid>
          <Grid.Row style={{ marginTop: 10 }}>
            <Grid.Column width={16}>
              <FormField id="pin-code-input" type="text" name="pinCode" />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </GridContainer>
    </Form>
  </LKModal>
)

const enhance = flowRight(
  LKModalContainer(PIN_CODE_MODAL),
  reduxForm({
    form: PIN_CODE_VALIDATION_FORM,
    validate: (values) => {
      const errors = {}

      if (!values.pinCode) {
        errors.pinCode = translate(`frm_custfield_add_edit-chk_required`)
      }

      return errors
    },
    onSubmit: ({ pinCode }, dispatch, { onConfirm }) => {
      onConfirm(pinCode)
    },
  }),
)

export default enhance(ValidatePinCodeModal)
